import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../../Common/Loader/loader";
import MUITable from "../../../../../Common/MUITable";
import { useTripStore } from "../../store/useTripStore";
import { ExportSATTripReport } from "./ExportSATTripReport";
import { formatDateTime, formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";

const SATTripReport = () => {
  const { tripDetails, isFetchingTripDetails } = useTripStore();
  const navigate = useNavigate();
  const { state } = useLocation();
  
  const columns = [
    {
      label: "Zone",
      field: "zone",
    },
    {
      label: "Circle",
      field: "circle",
    },
    {
      label: "Ward",
      field: "ward",
      width: 150,
    },
    {
      label: "Vehicle Type",
      field: "vehicleType",
      width: 200,
    },
    {
      label: "Vehicle Number",
      field: "vehicleNumber",
    },
    {
      label: "TS Name",
      field: "transferStationName",
    },
    {
      label: "Driver Name",
      field: "driverName",
    },
    {
      label: "Contact No",
      field: "driverNumber",
    },
    {
      label: "SFA Name",
      field: "primaryDeploymentInchargeName",
    },
    {
      label: "SFA Contact No",
      field: "primaryDeploymentInchargeMobileNumber",
    },
    {
      label: "Trips to TS/SCTP",
      field: "trips",
      render: row => row.trips
    },
    {
      label: "Reported Time",
      field: "scannedDateTime",
      render: row => row.scannedDateTime ? formatDateTime(row.scannedDateTime) : "N/A"
    },
  ];
  return (
    <>
      <div className="content">
        <div className="page-content">
          <div className="page-header">
            <div className="card">
              <div className="card-body">
                <div class="d-flex justify-content-end mt-3 mb-3">
                  <button
                    class="btn btn-secondary  me-2"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <ExportSATTripReport data={state} />
                </div>
                <div class="top-header">
                  <span>{state.circleName} {state.zoneName} {state.colName} ({formatDateTimeWithoutSec(state.FromDateTime)} To {formatDateTimeWithoutSec(state.ToDateTime)}) (at {getCurrentDateTime1()})</span>
                </div>
                <div>
                  {isFetchingTripDetails && <Loader />}
                  <MUITable
                    needSRNumber
                    rows={tripDetails}
                    columns={columns}
                    tableHeight={500}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SATTripReport;